module.exports = __webpack_public_path__ + "static/img/logo.1770538668457.png";